import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getMainContacts } from '../../../../../api/auth';
import { TSocial } from '../../../../../models/Main';

export const useMainContacts = () => {
  const { t } = useTranslation(['translation']);
  const [data, setData] = useState<TSocial[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    getMainContacts()
      .then((res) => setData(res))
      .finally(() => setIsLoading(false));
  }, [t]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    isLoading,
  };
};
